module.exports = __webpack_public_path__ + "static/media/logo-long.cb735512.svg";